import React from 'react';
import ErrorFallbackModal from './ErrorFallbackModal';

const CHUNK_RELOAD_KEY = 'chunkReloadAttempted';

function isChunkError(error) {
    if (!error) return false;
    // ChunkLoadError from webpack
    if (error.name === 'ChunkLoadError') return true;
    // SyntaxError when server returns HTML (e.g. 404 page) instead of JS
    if (error instanceof SyntaxError && error.message && error.message.includes("'<'")) return true;
    return false;
}

class ChunkErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        if (isChunkError(error)) {
            const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY);
            if (!alreadyReloaded) {
                // Mark that we attempted a reload so we don't loop infinitely
                sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
                window.location.reload();
                return;
            }
            // Already tried reloading — fall through to render ErrorFallbackModal
        }
    }

    resetErrorBoundary = () => {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <ErrorFallbackModal
                    error={this.state.error}
                    resetErrorBoundary={this.resetErrorBoundary}
                />
            );
        }
        return this.props.children;
    }
}

export default ChunkErrorBoundary;
